
define('modules/application/wizard/steps/zoneStep/complexZoneStep/automationSimpleZoneStep/zoneMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zoneMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  zoneMenuView) {

  var automationSimpleZoneMenuView = zoneMenuView.extend({
    template  : "application/wizard/steps/zones/complexZones/automationSimpleZones/menu-item",
    serialize : function() {
      return {model : this.model, appModel:BticinoS4B.Instances.Models.ApplicationModel};
    },
    initialize: function() {
      zoneMenuView.prototype.initialize.apply(this);

      this.model.bind("render:requested", this.render, this);
      BticinoS4B.Instances.Models.ApplicationModel.unbind("change:lightPointsAddressesLength", this.updateCounter);
      BticinoS4B.Instances.Models.ApplicationModel.bind("change:lightPointsAddressesLength", this.updateCounter, this);
      BticinoS4B.Instances.Models.ApplicationModel.unbind("change:enginesAddressesLength", this.updateCounter);
      BticinoS4B.Instances.Models.ApplicationModel.bind("change:enginesAddressesLength", this.updateCounter, this);
    },
    updateCounter : function() {
      var lightPointsAddressesLength = (!isNaN(BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsAddressesLength")) ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsAddressesLength") : 0),
          enginesAddressesLength     = (!isNaN(BticinoS4B.Instances.Models.ApplicationModel.get("enginesAddressesLength"))     ? BticinoS4B.Instances.Models.ApplicationModel.get("enginesAddressesLength")     : 0);

      $('.zone.selected').find(".addressCounter").html((lightPointsAddressesLength+enginesAddressesLength)+"/81");
    }
  });

  //Creating final automationtep class
  automationSimpleZoneMenuView.extend({
    objClass      : "automationSimpleZoneMenuView"
  });

  // Required, return the module for AMD compliance
  return automationSimpleZoneMenuView;

});